import { render, staticRenderFns } from "./Mates.vue?vue&type=template&id=f83b4a28&scoped=true"
import script from "./Mates.vue?vue&type=script&lang=js"
export * from "./Mates.vue?vue&type=script&lang=js"
import style0 from "./Mates.vue?vue&type=style&index=0&id=f83b4a28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83b4a28",
  null
  
)

export default component.exports